import { Column } from '@tanstack/react-table';
import { CSSProperties } from 'react';

export const getPinnedStyles = (
  column: Column<any, unknown>
): CSSProperties => {
  const isPinned = column.getIsPinned();
  if (!isPinned) return {};

  return {
    left: isPinned === 'left' ? `${column.getStart('left')}px` : undefined,
    right: isPinned === 'right' ? `${column.getAfter('right')}px` : undefined,
    position: 'sticky',
    zIndex: 10,
    backgroundColor: 'inherit',
  };
};
